export default __webpack_public_path__ + "static/media/ar_2018_image.9cd1f833.png";